import { Box, theme } from "@pallet-hq/hegel"
import ContentLoader from "react-content-loader"

const MiniTeamProfileLoader = () => {
    return (
        <Box
            maxWidth="400px"
            width="100%"
            display="flex"
            flexDirection="column"
            gridGap="small"
            p="small"
            border={`0.75px solid ${theme.colors.gray300}`}
            borderRadius="12px"
            style={{ boxSizing: "border-box" }}
        >
            <ContentLoader
                speed={2}
                height="212px"
                backgroundColor={theme.colors.gray300}
                foregroundOpacity={0.25}
                stroke="none"
                display="block"
            >
                <circle cx="24" cy="24" r="24" />
                <rect x="0" y="64" rx="12" ry="12" width="124" height="28" />
                <rect x="0" y="100" rx="12" ry="12" width="95%" height="24" />
                <rect x="0" y="150" rx="12" ry="12" width="96" height="24" />
                <rect x="104" y="150" rx="12" ry="12" width="96" height="24" />
                <rect x="208" y="150" rx="12" ry="12" width="124" height="24" />
                <rect x="0" y="184" rx="12" ry="12" width="154" height="24" />
                <rect x="162" y="184" rx="12" ry="12" width="104" height="24" />
            </ContentLoader>
            <Box p="small" backgroundColor="gray100" borderRadius="12px">
                <ContentLoader
                    speed={2}
                    height="86px"
                    backgroundColor={theme.colors.gray300}
                    foregroundOpacity={0}
                    stroke="none"
                    display="block"
                >
                    <rect x="0" y="0" rx="6" ry="6" width="124" height="16" />
                    <rect
                        x="0"
                        y="30"
                        rx="12"
                        ry="12"
                        width="100%"
                        height="18"
                    />
                    <rect
                        x="0"
                        y="64"
                        rx="12"
                        ry="12"
                        width="25%"
                        height="18"
                    />
                    <rect
                        x="27%"
                        y="64"
                        rx="12"
                        ry="12"
                        width="40%"
                        height="18"
                    />
                    <rect
                        x="69%"
                        y="64"
                        rx="12"
                        ry="12"
                        width="30%"
                        height="18"
                    />
                </ContentLoader>
            </Box>
        </Box>
    )
}

export { MiniTeamProfileLoader }
